import React, { useState, useEffect } from 'react';
import api from '../../api/api';

const ConectarWhatsapp = () => {
    const [qrCode, setQrCode] = useState(null);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState('DESCONECTADO'); // Pode ser: DESCONECTADO, AGUARDANDO_QR, CONECTADO

    // --- A MAGIA ACONTECE AQUI: O "Radar" (Polling) ---
    useEffect(() => {
        let intervalo;

        // Se o QR Code está na tela, começamos a perguntar ao servidor a cada 3 segundos
        if (status === 'AGUARDANDO_QR') {
            intervalo = setInterval(async () => {
                try {
                    const res = await api.get('/assinante/whatsapp/status');
                    
                    // Se a API responder que está aberto (open)
                    if (res.data.status === 'open') {
                        setStatus('CONECTADO');
                        setQrCode(null); // Esconde a imagem do QR Code
                        
                        // Feedback visual imediato
                        alert("✅ WhatsApp escaneado e conectado com sucesso!"); 
                    }
                } catch (error) {
                    console.log("A verificar status silenciosamente...");
                }
            }, 3000); 
        }

        // Limpa o relógio se o usuário sair da página ou o status mudar
        return () => clearInterval(intervalo);
    }, [status]);

    const gerarQrCode = async () => {
        setLoading(true);
        setStatus('AGUARDANDO_QR');
        
        try {
            const res = await api.post('/assinante/whatsapp/gerar-qr');
            setQrCode(res.data.qrCodeBase64); // Pega o Base64 do backend
        } catch (error) {
            console.error("Erro ao gerar QR Code", error);
            alert("Erro ao conectar ao servidor de WhatsApp.");
            setStatus('DESCONECTADO');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '40px', color: 'white', background: '#020617', minHeight: '100vh' }}>
            <h2>📱 Conectar WhatsApp da Clínica</h2>
            <p style={{ color: '#94a3b8' }}>
                Conecta o WhatsApp para automatizar o envio de acordos e cobranças.
            </p>

            <div style={{ 
                background: 'rgba(255,255,255,0.05)', 
                padding: '30px', 
                borderRadius: '12px', 
                maxWidth: '500px', 
                textAlign: 'center',
                marginTop: '20px',
                border: status === 'CONECTADO' ? '1px solid #10b981' : '1px solid rgba(255,255,255,0.1)'
            }}>
                
                {status === 'DESCONECTADO' && !loading && (
                    <button 
                        onClick={gerarQrCode} 
                        style={{ background: '#10b981', padding: '15px 30px', borderRadius: '8px', border: 'none', fontWeight: 'bold', cursor: 'pointer', color: 'white' }}
                    >
                        Gerar QR Code de Conexão
                    </button>
                )}

                {loading && <p style={{ color: '#fbbf24' }}>A inicializar máquina virtual... aguarda uns segundos.</p>}

                {qrCode && status === 'AGUARDANDO_QR' && (
                    <div>
                        <h3>Lê o QR Code com o teu WhatsApp</h3>
                        <img 
                            src={qrCode} 
                            alt="QR Code WhatsApp" 
                            style={{ width: '250px', height: '250px', borderRadius: '10px', padding: '10px', background: 'white' }} 
                        />
                        <p style={{ fontSize: '0.8rem', color: '#f59e0b', marginTop: '15px' }}>
                            ⏳ Aguardando leitura automática...
                        </p>
                    </div>
                )}

                {/* --- TELA DE SUCESSO --- */}
                {status === 'CONECTADO' && (
                    <div style={{ animation: 'fadeIn 1s' }}>
                        <div style={{ fontSize: '60px', marginBottom: '10px' }}>✅</div>
                        <h3 style={{ color: '#10b981' }}>Escaneado com Sucesso!</h3>
                        <p style={{ color: '#94a3b8' }}>O seu WhatsApp está conectado e pronto para uso no sistema.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ConectarWhatsapp;